import { render, staticRenderFns } from "./dataReport.vue?vue&type=template&id=2f228274&scoped=true&"
import script from "./dataReport.vue?vue&type=script&lang=js&"
export * from "./dataReport.vue?vue&type=script&lang=js&"
import style0 from "./dataReport.vue?vue&type=style&index=0&id=2f228274&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f228274",
  null
  
)

export default component.exports